import React from 'react';
import {defaultTemplate} from 'core/hoc';
import {BasicCheckbox} from 'core/components';
import { toDate, isNikoFlowTask } from 'core/utils';
import _ from 'lodash';

const FutureTasksTemplate = defaultTemplate(({ title, onChange, data, openFacilityEdit, openPickTicketEdit, openNikoFacilityOrder, downloadNikoPickTicketExcel }) => {
  let sections = [];

  _.each(data, (groupItems, groupDate) => {
    let rows = groupItems.map(task =>
        <tr title={task.facility.address} key={task.id}>
            <td>
                <strong><a className={task.sendOrder ? 'table__send-order':''} onClick={() => openFacilityEdit(task.facility.id)}>{task.name}</a></strong>
                {
                    !isNikoFlowTask(task.facility, task.dateOfService) && task && task.facilityOrder && task.facilityOrder.pickTicketHeaderId && !task.isWoundCare && task.facilityOrder.sendOrder &&
                    <strong> - <a  className={task.sendOrder ? 'table__send-order':''} onClick={() => openPickTicketEdit(task.facilityOrder, task.facilityOrder.pickTicketHeaderId)}> Pick Ticket</a></strong>
                }
                {task.facility.deliveryNote && <div className="table--has-note">
                    <i className="u-icon u-icon--sml u-icon--note u-icon--text-top"></i>
                    <span className="table__note">{task.facility.deliveryNote}</span>
                </div> }
                {task.notes && <div className="table--has-note">
                    <i className="u-icon u-icon--sml u-icon--note u-icon--text-top"></i>
                    <span className="table__note">{task.notes}</span>
                </div> }
                <div className="u-mar--top--tny">
                    {task.originalAccountRep  &&
                    <div className="table__tag table__tag--user">
                        <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                        <span>{task.originalAccountRep}</span>
                    </div>
                    }
                    {task.originalIntakeRep  &&
                    <div className="table__tag table__tag--user">
                        <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                        <span>{task.originalIntakeRep}</span>
                    </div>
                    }
                    {task.originalPayorRep  &&
                    <div className="table__tag table__tag--user">
                        <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                        <span>{task.originalPayorRep}</span>
                    </div>
                    }
                    {task.originalDocumentRep  &&
                    <div className="table__tag table__tag--user">
                        <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                        <span>{task.originalDocumentRep}</span>
                    </div>
                    }
                    {task.originalBillingRep  &&
                    <div className="table__tag table__tag--user">
                        <i className="u-icon u-icon--xsml u-icon--new-person u-mar--right--tny"></i>
                        <span>{task.originalBillingRep}</span>
                    </div>
                    }
                    {task.originalDate && 
                    <div className="table__tag table__tag--date">
                        <i className="u-icon u-icon--xsml u-icon--schedule-update u-mar--right--tny"></i>
                        <span>{toDate(task.originalDate)}</span>
                    </div>}
                    {task.facility.shipPoint >= 2 &&
                    <div className="table__tag table__tag--facility">
                        <span>{task.facility.shipPoint} Ship Point</span>
                    </div>
                    }
                    {task.facility.partBOnly &&
                    <div className="table__tag table__tag--facility">
                        <span>Part B Only</span>
                    </div>}
                    {task.isNewFacility &&
                    <div className="table__tag table__tag--facility">
                        <i className="u-icon u-icon--xsml u-icon--new-facility u-mar--right--tny"></i>
                        <span>New Facility</span>
                    </div>
                    }
                </div>
            </td>
            <td className="type--right" style={{ whiteSpace: 'nowrap' }}>
                {isNikoFlowTask(task.facility, task.dateOfService) && task.facilityOrder && task.facilityOrder.id && !task.isWoundCare &&
                    <a title="Access Facility Order" className="u-mar--right--sml u-cursor--pointer" onClick={() => openNikoFacilityOrder(task.facilityOrder.id)}>
                        <i className="u-icon u-icon--package--grey u-icon--sml"></i>
                    </a>
                }
                {
                    isNikoFlowTask(task.facility, task.dateOfService) && task.facilityOrder && task.facilityOrder.id && !task.isWoundCare && task.facilityOrder.sendOrder &&
                    <a title="Download Excel Pick Ticket" className="u-mar--right--sml u-cursor--pointer" onClick={() => downloadNikoPickTicketExcel(task.facilityOrder.id)}>
                        <i className="u-icon u-icon--download u-icon--sml"></i>
                    </a>
                }
                <BasicCheckbox id={task.id} checked={task.isDone} onChange={() => onChange(task)} />
            </td>
        </tr>);

        let section = 
        <React.Fragment key={"groupDate" + groupDate}>
            <h6 className="form__title form__title--sub form__title--list">{groupDate}</h6>
            <table className="table--tasks2 u-mar--bottom--med">
                <tbody>
                    {rows}
                </tbody>
            </table>
        </React.Fragment>

        sections.push(section);
  });

    return (
        <React.Fragment>
            <div className="col col-sml-12 col-lrg-6 u-mar--bottom--med col--flex">
            <div className="card card--form card--primary card--med card--flex">
                <h4 className="form__title form__title--preview">{title}</h4>
                {sections.length > 0 ? sections : <React.Fragment>No tasks for today.</React.Fragment>}
            </div>
            </div>
        </React.Fragment>
    )
});

export default FutureTasksTemplate;